export default __webpack_public_path__ + "static/media/sid-icon.079e658d.svg";